import React from 'react';

import TaskGroupSelect from 'components/TaskGroupSelect';
import MilestoneName from 'components/milestone-name';
import TaskName from 'components/task-name';
import Tooltip from 'components/tooltip';
import Checkbox from 'components/checkbox';

import IconLock from 'icons/icon-lock';

import './TaskCompleteToggle.styles.scss';

const TaskCompleteToggle = ({ disabled, completed, locked, dependantOn, projectId, size = 'default', selectListDisabled, onChange }) => {
    const handleCompletedToggle = state => {
        if (!disabled && !locked && !dependantOn && (!selectListDisabled && completed && projectId)) {
            return;
        }

        onChange && onChange(state);
    }

    const handleTaskGroupSelect = ({ id }) => {
        onChange && onChange(false, id);
    }

    const getTooltipContent = (completed, dependantOn) => {
        if (dependantOn) {
            return (
                <React.Fragment>
                    Dependent on {dependantOn.type}&nbsp;
                    {
                        dependantOn.type === 'milestone' ? <MilestoneName id={dependantOn.id} /> : <TaskName id={dependantOn.id} />
                    }
                </React.Fragment>
            );
        }

        if (completed) {
            return 'Mark task uncomplete'
        }

        return 'Mark task complete';
    }

    const checkboxElement = <Checkbox disabled={disabled || locked || dependantOn} forceUseProp={true} alwaysTick={true} inverted={true} checked={completed} onChange={handleCompletedToggle} />;

    return (
        <Tooltip showDelay={1000} tooltip={getTooltipContent(completed, dependantOn)} disabled={disabled || locked}>
            <div className={'task-complete-toggle size-' + size}>
                {
                    !selectListDisabled && !disabled && !locked && !dependantOn && completed && projectId ? (
                        <TaskGroupSelect
                            projectId={projectId}
                            onSelect={handleTaskGroupSelect}
                        >
                            <div>
                                { checkboxElement }
                            </div>
                        </TaskGroupSelect>
                    ) : checkboxElement
                }
                

                {
                    locked || dependantOn ? (
                        <span className="dep-icon"><IconLock /></span>
                    ) : null
                }
            </div>
        </Tooltip>
    );
}

export default TaskCompleteToggle;
